import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-action-logs',
    imports: [
        CommonModule,
        MatTableModule,
        MatPaginatorModule,
        MatCardModule,
        MatInputModule,
        MatFormFieldModule,
        FormsModule
    ],
    templateUrl: './action-logs.component.html',
    styleUrl: './action-logs.component.scss'
})
export class ActionLogsComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['created_at', 'message','username', 'church_id', 'topic'];
  data:any[] = [];
  totalLogs = 0;
  pageSize = 10;
  isLoading = false;
  filterValues: { [key: string]: string } = {};

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private apiService: ApiService) {
  }

  ngOnInit() {
    this.loadLogs(0, this.pageSize);
  }

  ngAfterViewInit() {
  }

  loadLogs(pageIndex: number, pageSize: number) {
    this.isLoading = true;
    this.apiService.getActionLogs(pageIndex +1, pageSize).subscribe({
      next: (res) => {
        this.data = res.items;
        if(this.totalLogs != res.total){
          this.totalLogs = res.total;
        }
        this.pageSize = res.per_page;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  onPageChange(event: any) {
    this.loadLogs(event.pageIndex, event.pageSize);
  }

}
